import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";
import { CssBaseline } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary:   { main: "rgba(106, 26, 26, 0.85)" }, // Weinrot dunkel
        secondary: { main: "#9c4343" }, // Weinrot hell
        background:{ default: "#f4f4f4", paper: "#ffffff" },
        text:      { primary: "#1e1e1e", secondary: "#5f5f5f" },
        grey:      { 50: "#fafafa", 75: "#f7f7f7", 100: "#f2f2f2", 150: "#ededed" },
    },
    typography: {
        fontFamily: "Roboto, system-ui, -apple-system, Segoe UI, Arial, sans-serif",
        h4: { fontWeight: 700, letterSpacing: "0.02em" },
        body1: { lineHeight: 1.7 },
    },
    shape: { borderRadius: 14 },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: { boxShadow: "0 8px 24px rgba(106,26,26,0.18)" },
            },
        },
        MuiButton: {
            styleOverrides: { root: { borderRadius: 999, textTransform: "none", fontWeight: 500 } },
        },
    },
});

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
        </ThemeProvider>
    </React.StrictMode>
);
